import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const PanelWrapper = styled.div({
	marginLeft: token('space.negative.100', '-8px'),
	marginRight: token('space.negative.100', '-8px'),
	marginBottom: token('space.300', '24px'),
});
